<template>
  <v-container>
    <!-- <v-alert outlined type="info" text dismissible="">
      We are currently migrating pricing plans over to this dashboard. If your
      plan does not show up, reach out to support@arist.co
    </v-alert> -->
    <v-row class="pa-0 ma-0">
      <v-col class="col-12 pa-3">
        <h1>My Plan</h1>
        <v-card
          width="100%"
          flat=""
          outlined=""
          style="overflow:hidden;"
          :loading="loading"
        >
          <v-tabs>
            <v-tab :to="{ name: 'billing-account' }" exact="">
              My Account
            </v-tab>
            <v-tab :to="{ name: 'billing-plans' }" exact="" v-if="!enterprise">
              Plans
            </v-tab>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
    <router-view :hide="enterprise" />
  </v-container>
</template>
<style scoped>
.payment-card {
  max-width: 600px;
  width: 100%;
}
</style>
<script>
import services from "@/services";
export default {
  data: () => ({
    enterprise: true,
    tab: null,
    loading: true,
    text:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    icons: false,
    centered: false,
    grow: false,
    vertical: false,
    prevIcon: false,
    nextIcon: false,
    right: false,
    tabs: 3,
    features: {
      free: [
        "Create unlimited courses",
        "Unlimited learners",
        "Charge for your courses",
        "Detailed analytics",
        "In-text quizzes and surveys",
        "Course previews",
        "Deploy courses across SMS and WhatsApp",
        "Free content guides"
      ],
      growth: [
        "Everything in Starter Plan",
        "Let learners enroll in seconds with no sign up",
        "Access our Content Editor community",
        "Unlimited admins",
        "Unlimited classrooms",
        "Your own logo + whitelabeling",
        "Data exportation",
        "FERPA and SOPIPA compliance"
      ],
      enterprise: [
        "Everything in Starter Plan",
        "Everything in Growth Plan",
        "Unlimited courses per learner",
        "Custom onboarding and workshops",
        "LMS and SSO integrations",
        "Seamless pilot options",
        "Let our team quickly create and covert courses for you",
        "Assign courses to learners",
        "Let learners enroll by texting a code",
        "Course library included"
      ]
    }
  }),
  methods: {
    async isEnterprise() {
      const account = await services.billing.accounts.get();
      return account && account.metadata
        ? account.metadata.locked === "true"
          ? true
          : false
        : false;
    }
  },
  async mounted() {
    try {
      if (this.$store.getters["enterprise"] != "unloaded") {
        return (this.enterprise = this.$store.getters["enterprise"]);
      }
      const isEnt = await this.isEnterprise();
      console.log("ENT", isEnt);
      this.$store.commit("enterprise", isEnt);
      this.enterprise = isEnt;
    } catch (err) {
      console.log(err);
    } finally {
      this.loading = false;
    }
  }
};
</script>

<style></style>
